import { render, staticRenderFns } from "./tos.vue?vue&type=template&id=8dc2d812&scoped=true&"
import script from "./tos.vue?vue&type=script&lang=js&"
export * from "./tos.vue?vue&type=script&lang=js&"
import style0 from "./tos.vue?vue&type=style&index=0&id=8dc2d812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc2d812",
  null
  
)

export default component.exports